;(() => {
  //we don't want to open the cart drawer on the newsletter subscribe page or captcha challenge pages, as the user is still in the journey of signing up to the newsletter
  //when the user submits the form successfully, we then want this functionality to run
  const htmlElement = document.querySelector('html')
  const blockPagesOpenCart =
    ['template-page-newsletter-subscribe', 'template-cart'].some((cls) =>
      htmlElement.classList.contains(cls)
    ) || window.location.pathname === '/challenge'

  const blockPagesRedirectTo =
    htmlElement.classList.contains('template-page-newsletter-subscribe') ||
    window.location.pathname === '/challenge'

  if (sessionStorage.getItem('redirect-to') && !blockPagesRedirectTo) {
    window.location.href = sessionStorage.getItem('redirect-to')
    sessionStorage.removeItem('redirect-to')
  }

  //this is needed to open the cart drawer after the user clicks 'sign-in below the spend and save discount progress bar'
  if (sessionStorage.getItem('open-cart-drawer') && !blockPagesOpenCart) {
    setTimeout(() => {
      const button = document.querySelector('button#open-cart-drawer')
      button.click()
      sessionStorage.removeItem('open-cart-drawer')
    }, 500)
  }
})()
